module.exports = __webpack_public_path__ + "img/2025-02-13a_1.da5f0db3.jpg";